export default __webpack_public_path__ + "static/media/settingDelete.ba3982dd.svg";